
















import { Component, Prop, Vue } from 'vue-property-decorator';
import { Dropdown, DropdownMenu, DropdownItem } from 'element-ui';
import { CalloutOption } from '@/types/types';

@Component({
  components: {
    'el-dropdown': Dropdown,
    'el-dropdown-menu': DropdownMenu,
    'el-dropdown-item': DropdownItem
  }
})
export default class Callout extends Vue {
  @Prop({ required: true }) private items!: CalloutOption<any>[] | string[];

  private label = {
    copy: {
      label: 'document.copy'
    },
    delete: {
      label: 'shared.delete'
    },
    edit: {
      label: 'shared.edit'
    }
  };

  handleCommand(item: CalloutOption<any> | string) {
    if (typeof item === 'string') {
      return this.$emit(item);
    }

    this.$emit(item.event, item && item.eventArgs);
  }
}
